import { BreakpointMinSizes } from "@omni/types/enums/breakPoint.enum";

import { attributeToBoolean } from "@/utils/attributes";
import { BreakpointMatches } from "@/utils/breakpoints/breakpoints.provider";

export type AemEnergyLabelRenditions = {
    thumbnail?: string;
    main?: string;
    zoom?: string;
    maxZoom?: string;
    altText: string;
};

const getImageRenditionByBreakpoint = (
    energyLabelLarge: AemEnergyLabelRenditions,
    breakpoints: BreakpointMatches
): string => {
    const EnergyLabelRenditions = {
        defaultRendition: energyLabelLarge?.main,
        xs: energyLabelLarge?.main,
        sm: energyLabelLarge?.main,
        md: energyLabelLarge?.main,
        lg: energyLabelLarge?.zoom,
        xl: energyLabelLarge?.zoom
    };

    return (
        // @ts-expect-error
        EnergyLabelRenditions[activeRendition(breakpoints)] ||
        energyLabelLarge.main
    );
};

const getImageRenditionOneByTwo = (
    energyLabelLarge: AemEnergyLabelRenditions,
    breakpoints: BreakpointMatches
): string => {
    const EnergyLabelRenditions = {
        defaultRendition: energyLabelLarge?.thumbnail,
        xs: energyLabelLarge?.thumbnail,
        sm: energyLabelLarge?.thumbnail,
        md: energyLabelLarge?.main,
        lg: energyLabelLarge?.main,
        xl: energyLabelLarge?.main
    };

    return (
        // @ts-expect-error
        EnergyLabelRenditions[activeRendition(breakpoints)] ||
        energyLabelLarge.main ||
        energyLabelLarge.zoom ||
        energyLabelLarge.maxZoom
    );
};

const activeRendition = (breakpoints: BreakpointMatches): string => {
    return (
        Object.keys(breakpoints)
            .reverse()
            .find((k) => breakpoints[k as BreakpointMinSizes]) ||
        "defaultRendition"
    );
};

const getImageRendition = (
    energyLabelLarge: AemEnergyLabelRenditions,
    oneByTwo: boolean,
    breakpoints: BreakpointMatches
): string => {
    let image;

    if (attributeToBoolean(oneByTwo)) {
        image = getImageRenditionOneByTwo(energyLabelLarge, breakpoints);
    } else {
        image = getImageRenditionByBreakpoint(energyLabelLarge, breakpoints);
    }

    return image;
};

export { getImageRendition };
